import BaseValidator from "./BaseValidator";

const currencyValidator = Object.create(BaseValidator);

currencyValidator.validateAgainstRegex = /^[0-9]+(?:,[0-9]{2})?$/;

export default currencyValidator.init();
